import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestTmtService } from '../rest-tmt.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-shared-print',
    templateUrl: './shared-print.component.html',
    styleUrls: ['./shared-print.component.scss']
})
export class SharedPrintComponent implements OnInit {

    public printData: any;
    public errorMessage = '';
    public days: any[] = [];
    public allDays: any = {
        hotels: [],
        flights: [],
        cars: [],
        optionals: [],
        escorteds: [],
        transfers: []
    };
    public extra: any = { fees: [], insurances: [] };
    public citiesImages: string[] = [];
    private bookId: string = '';

    constructor(
        private route: ActivatedRoute,
        private service: RestTmtService,
        private translateService: TranslateService,
        private titleService: Title
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.bookId = params['bookID'];
            if (this.bookId) {
                this.service.loadStyleTenant().then(() => {
                    this.getData(this.bookId, this.translateService.currentLang || 'it');
                });
            }
        });

        this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            if (this.bookId) {
                this.getData(this.bookId, event.lang === 'nl' ? 'en' : event.lang);
            }
        });
    }

    public getData(bookID: string, lang: string): void {
        this.service.getIter(bookID, lang).subscribe(
            response => {
                const iter = response;
                this.titleService.setTitle('Print Preview - ' + iter.name);
                if (iter.state) {
                    sessionStorage.setItem('state', iter.state);
                }

                const tenant = this.service.getClient();

                const extra = iter.extra || { fees: [], insurances: [] };
                let advInformations = {
                    feeFlight: 0,
                    feeLandServices: 0,
                    footerText: '',
                    hidePriceB2C: false
                };

                this.days = iter.days;
                this.removeDuplicatesDays();
                this.aggregateAllDays();

                this.citiesImages = [];
                if (iter.days) {
                    const ignoredCodes = tenant?.ignoredIsoCodes
                        ? (Array.isArray(tenant.ignoredIsoCodes)
                            ? tenant.ignoredIsoCodes
                            : tenant.ignoredIsoCodes.toString().split(',').map((c: string) => c.trim()))
                        : [];

                    for (const day of iter.days) {
                        if (!day.city_photo) {
                            continue;
                        }

                        if (ignoredCodes.length > 0 && ignoredCodes.includes(day.city_code ?? '')) {
                            continue;
                        }

                        this.citiesImages.push(day.city_photo);
                    }
                }

                this.printData = {
                    iter: iter,
                    days: this.days,
                    allDays: this.allDays,
                    extra: extra,
                    citiesImages: this.citiesImages,
                    urlCitiesImages: tenant.photoEndPoint || '',
                    logoAdv: iter.agency?.logo,
                    logoTourOperator: `assets/custom/${tenant.consolidator}/images/logo_tour_operator.png`,
                    consolidator: tenant.consolidator,
                    lastUpdate: iter.quotation_date_last,
                    footerText: '',
                    tenant: tenant,
                    noImageUrl: tenant.noImageUrl,
                    amountApis: iter.financialSummary,
                    advInformations: advInformations
                };
            },
            error => {
                this.errorMessage = 'Errore nel caricamento del viaggio.';
                console.error(error);
            }
        );
    }

    removeDuplicatesDays() {
        const sequenceNumbers: any = {};
        const filteredDays = this.days.map((day: any) => ({
            ...day,
            optionals: day.optionals.filter((optionals: any) => {
                if (sequenceNumbers[optionals.sequenceNumber]) {
                    return false;
                } else {
                    sequenceNumbers[optionals.sequenceNumber] = true;
                    return true;
                }
            }),
            transfers: day.transfers.filter((transfers: any) => {
                if (sequenceNumbers[transfers.sequenceNumber]) {
                    return false;
                } else {
                    sequenceNumbers[transfers.sequenceNumber] = true;
                    return true;
                }
            }),
            hotels: day.hotels.filter((hotel: any) => {
                if (sequenceNumbers[hotel.sequenceNumber]) {
                    return false;
                } else {
                    sequenceNumbers[hotel.sequenceNumber] = true;
                    return true;
                }
            }),
            escorteds: day.escorteds.filter((escorted: any) => {
                if (sequenceNumbers[escorted.sequenceNumber]) {
                    return false;
                } else {
                    sequenceNumbers[escorted.sequenceNumber] = true;
                    return true;
                }
            }),
            cars: day.cars.filter((car: any) => {
                if (sequenceNumbers[car.sequenceNumber]) {
                    return false;
                } else {
                    sequenceNumbers[car.sequenceNumber] = true;
                    return true;
                }
            }),
        }));
        this.days = filteredDays;
    }

    aggregateAllDays() {
        this.allDays = this.days.reduce((acc: any, day: any) => {
            if (day.hotels.length > 0) { acc.hotels.push(...day.hotels); }
            if (day.flights.length > 0) { acc.flights.push(...day.flights); }
            if (day.cars.length > 0) { acc.cars.push(...day.cars); }
            if (day.optionals.length > 0) { acc.optionals.push(...day.optionals); }
            if (day.escorteds.length > 0) { acc.escorteds.push(...day.escorteds); }
            if (day.transfers.length > 0) { acc.transfers.push(...day.transfers); }
            return acc;
        }, { hotels: [], flights: [], cars: [], optionals: [], escorteds: [], transfers: [], optionalsSuggested: [], transfersSuggested: [], extra: [] });

        this.allDays.hotels = this.removeDuplicates(this.allDays.hotels);
        this.allDays.cars = this.removeDuplicates(this.allDays.cars);
        this.allDays.transfers = this.removeDuplicates(this.allDays.transfers);
        this.allDays.optionals = this.removeDuplicates(this.allDays.optionals);
        this.allDays.escorteds = this.removeDuplicates(this.allDays.escorteds);
        this.allDays.extra = this.extra;
    }

    removeDuplicates(items: any[]) {
        return items.reduce((acc, item) => {
            if (!acc.some((el: any) => el.sequenceNumber === item.sequenceNumber)) {
                acc.push(item);
            }
            return acc;
        }, []);
    }

}
